module.exports = __webpack_public_path__ + "02243296a27adeaf6ac5794b917879a7.jpg";